import React, { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const ToolsHomePage = lazy(() => import('./ToolsHomePage'));
const PrivacyPolicyPage = lazy(() => import('./legal/PrivacyPolicy'));
const CookiePolicyPage = lazy(() => import('./legal/CookiePolicy'));

const App: React.FC = () => (
  <Suspense
    fallback={
      <div className="text-center p-5" aria-live="polite">
        Ładowanie…
      </div>
    }
  >
    <Routes>
      <Route path="/" element={<ToolsHomePage />} />
      <Route path="/legal/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/legal/cookie-policy" element={<CookiePolicyPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>
);

export default App;
